import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import Icon from 'src/common/components/IconDS22';
import styles from './ListingCard.module.scss';

type Props = {
  progress: number;
};
const ProgressStatus: FC<Props> = ({ progress }) => {
  const [t] = useTranslation('admin-listings');
  const complete = progress === 100;
  if (complete) return null;

  return (
    <div className={styles.progressBar}>
      <Icon id="warning" />
      {t('landing-page--listing-card--incomplete')}
    </div>
  );
};

export default ProgressStatus;
